export function getSlots(element, callback = () => {}, ignoreTextNodes = false) {
  let slots = new Map();
  const children = Array.from(ignoreTextNodes ? element.container.children : element.container.childNodes);
  children.forEach((child)=> {
    if(!child.slot) {
      const defaultSlot = slots.get('default') || [];
      slots.set('default', defaultSlot.concat(child));
      callback?.(child,'default');
    }else {
      const slotName = child.slot;
      const slotContent = slots.get(slotName) || [];
      slots.set(slotName, slotContent.concat(child));
      callback?.(child,slotName);
    }
  });
  return slots;
}

export const rectifyUndefinedState = (element) => (element!=='undefined') ? element : undefined;


/* removeSpacesAndSpecialChars */
export const pureKeys = (str) => {
  // Use a regular expression to replace spaces and special characters with an empty string
  return str.replace(/[^a-zA-Z0-9]/g, '');
}

export const regEx = {
  emailValidation: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
  emailPattern:/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
  alphabetValidation: /^[A-Za-z]+$/,
  alphabetWithSpaceValidation: /^[a-zA-Z\s]*$/,
  alphabetWithSpaceNumberValidation : /^[A-Za-z0-9\s]*$/,
  alphabetWithStreetValidation :/^(?!.*[<>[\]=|`\\]).*$/,
  numberValidation: /^[0-9]+$/,
  numberWithDecimalValidation : /^[0-9]+(\.[0-9]+)?$/,
  textAreaValidation : /^[A-Za-z0-9-~!@#%&"+?$\r\n^*()_{}/:;,'. ]*$/
}

export const createElementFromSlots = (...props) => {
  const [el, elementName, ...properties] =props;
  const element = document.createElement(elementName);
  properties.forEach((prop)=>
  {
    if(el[prop] && typeof(el[prop])==='object'){
      const item = el[prop];
      let childObj = {}, childObjStr='';
      const keyName = item[0]?elementName:undefined;
      if(keyName){
        childObj[keyName] = item;
        childObjStr = JSON.stringify(childObj);
      } else {
        childObjStr = JSON.stringify(item);
      }
      element.setAttribute(prop, childObjStr);
    } else {
      el[prop] && element.setAttribute(prop, el[prop]);
    }
  })
  return element;
}

export const checkActive =(val)=> {
  return val === true;
}

/* throttle */
export const throttle = (fn, threshold = 250, scope) => {
	let last;
	let deferTimer;

	// eslint-disable-next-line func-names
	return function () {
		const context = scope || this;
		const now = +new Date();
		// eslint-disable-next-line prefer-rest-params
		const args = arguments;

		if (last && now < last + threshold) {
			clearTimeout(deferTimer);
			deferTimer = setTimeout(() => {
				last = now;
				fn.apply(context, args);
			}, threshold);
		} else {
			last = now;
			fn.apply(context, args);
		}
	};
};

/* isElementInViewport */
export function isElementInViewport(element, container) {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return (
      elementRect.top >= containerRect.top &&
      elementRect.left >= containerRect.left &&
      elementRect.bottom <= containerRect.bottom &&
      elementRect.right <= containerRect.right
  );
}

export const capitalize =(s)=>{
  return s.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );
};

export const isSyntheticEvent = (event) => ('nativeEvent' in event && 'preventDefault' in event && 'stopPropagation' in event);

export const isMobile = () => (
  ('ontouchstart' in window || navigator.maxTouchPoints>0) && (window.innerWidth<=800)
)

export const isTablet = () => (
  ('ontouchstart' in window || navigator.maxTouchPoints>0) && (window.innerWidth<=1600 && window.innerWidth >=768)
)

export const isLgClass = () => window.innerWidth>=1024;

export const isXlClass = () => window.innerWidth>=1280;

export const is2XlClass = () => window.innerWidth>=1440;

export const isDesktop = () => {
  const hasFinePointer = matchMedia('(pointer: fine)').matches;
  const noPrimaryTouchInterface = matchMedia('(hover:hover)').matches;
  return hasFinePointer && noPrimaryTouchInterface;  
}

export const isLandscape = () => window.innerWidth > window.innerHeight;

export const isAllow = (val) => {
  return (val.length >= 3 && val !== '') ? true : false;
}

export const sortedOptions = (options) => options.sort((a, b) => a.label.localeCompare(b.label));

export const sortAlphaFirstOptions = (options) => {
  return options.sort((a,b)=>{
    const isASpecial = /^[^a-zA-Z]/.test(a.label);
    const isBSpecial = /^[^a-zA-Z]/.test(b.label);
    return isASpecial===isBSpecial? a.label.localeCompare(b.label) : isASpecial? 1: -1;
  })
}

//GTM Events
export const PushGADataLayer = (eventCategory, eventAction, eventLabel) => {
  window.dataLayer.push(
      {
          'event': 'eventTracker',
          'eventCategory': eventCategory,
          'eventAction': eventAction,
          'eventLabel': eventLabel,
          'eventValue': 0,
          'nonInteraction': 0
      });
}